import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/** Props for the {@link FullPageSpinner} component. */
export type FullPageSpinnerProps = HTMLAttributes<HTMLDivElement>;

/**
 * Centered full-viewport spinner used as a loading indicator
 * during auth initialization or lazy route loading.
 */
export function FullPageSpinner({ className, ...props }: FullPageSpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center min-h-svh', className)} {...props}>
      <div className="size-8 border-3 border-accent border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
